// components/Loader.jsx
import React from 'react';
import './Loader.css';

const Loader = () => {
  return (
    <div className="loader-container">
      <div className="loader-bar"></div>
    </div>
  );
};

export default Loader;
